/**
 * scopeTabsSelect — mobile <select> mirror of a listing scope tab strip
 * (MOHO-103). On small viewports the .listing-tabs strip is hidden and this
 * select is shown; picking an option navigates to that tab's URL. Routes
 * through navigateTo() so it's the same no-reload Swup visit as clicking a tab,
 * with a hard-navigation fallback before the router boots (server-first).
 */
import { navigateTo } from '../router/swup.js';

export default function scopeTabsSelect() {
    return {
        go(url) {
            if (url) {
                navigateTo(url);
            }
        },
    };
}
